import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	getStartedButton: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.create-virtual-agent-section.get-started-button',
		defaultMessage: 'Get started',
		description: 'Text for the button to set up the virtual service agent.',
	},
});
